import React from 'react';
import { Bold, Italic, List, ListOrdered, AlignLeft, AlignCenter, AlignRight } from 'lucide-react';
interface RichTextEditorProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
}
export function RichTextEditor({
  label,
  value,
  onChange,
  error
}: RichTextEditorProps) {
  return <div className="w-full" data-id="element-301">
      {label && <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-302">
          {label}
        </label>}
      <div className={`border rounded-lg overflow-hidden ${error ? 'border-red-500' : 'border-gray-300'}`} data-id="element-303">
        <div className="bg-gray-50 border-b border-gray-300 p-2 flex gap-1" data-id="element-304">
          <button className="p-2 hover:bg-gray-200 rounded" title="Bold" data-id="element-305">
            <Bold className="w-4 h-4 text-gray-600" data-id="element-306" />
          </button>
          <button className="p-2 hover:bg-gray-200 rounded" title="Italic" data-id="element-307">
            <Italic className="w-4 h-4 text-gray-600" data-id="element-308" />
          </button>
          <div className="w-px bg-gray-300 mx-1" data-id="element-309" />
          <button className="p-2 hover:bg-gray-200 rounded" title="Bullet List" data-id="element-310">
            <List className="w-4 h-4 text-gray-600" data-id="element-311" />
          </button>
          <button className="p-2 hover:bg-gray-200 rounded" title="Numbered List" data-id="element-312">
            <ListOrdered className="w-4 h-4 text-gray-600" data-id="element-313" />
          </button>
          <div className="w-px bg-gray-300 mx-1" data-id="element-314" />
          <button className="p-2 hover:bg-gray-200 rounded" title="Align Left" data-id="element-315">
            <AlignLeft className="w-4 h-4 text-gray-600" data-id="element-316" />
          </button>
          <button className="p-2 hover:bg-gray-200 rounded" title="Align Center" data-id="element-317">
            <AlignCenter className="w-4 h-4 text-gray-600" data-id="element-318" />
          </button>
          <button className="p-2 hover:bg-gray-200 rounded" title="Align Right" data-id="element-319">
            <AlignRight className="w-4 h-4 text-gray-600" data-id="element-320" />
          </button>
        </div>
        <textarea value={value} onChange={e => onChange(e.target.value)} rows={6} className="w-full px-3 py-2 text-sm focus:outline-none resize-none" placeholder="Enter description..." data-id="element-321" />
      </div>
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-322">{error}</p>}
    </div>;
}